import React from 'react';
import { Text, Button, Card, Layout, Input, Select } from '@ui-kitten/components';
import { StyleSheet, View, Platform } from 'react-native';
import { getCurrentUser } from '../../utils/getCurrentUser';
import { useMutation } from '@apollo/react-hooks';
import { M_CREATE_CAMPAIGN } from './../../data/api/mutation/m_campaigns';
import { PageLoadingIndicator } from '../../components/LoadingIndicator';
import { useScreenDimensions, getItemWidth } from '../../utils/useScreenInfo';

const HEADER_TOP_MARGIN: number = Platform.OS === 'web' ? 0 : -2;


const useInputChanges = (initialValue = '') => {
    const [value, setValue] = React.useState(initialValue);
    return {
        value,
        onChangeText: setValue,
    };
};

const useSelectChanges = (initialValue = { text: '' }) => {
    const [selectedOption, setValue] = React.useState(initialValue);
    return {
        selectedOption,
        onSelect: setValue,
    };
};



export default function CreateCampaignScreen({ navigation, route }): React.ReactElement {
    const { isMediumScreenOrLarger, isLargeScreenOrLarger } = useScreenDimensions();
    const { pageSpacerHorizontal } = getItemWidth({ isMediumScreenOrLarger, isLargeScreenOrLarger });
    const params = route?.params;
    console.log({ navigation, route, params });

    const renderHeader = (): React.ReactElement => (
        <View style={{ padding: 30 }}>
            <Text category='h2'>{'Create Campaign'}</Text>
            {/* <Text category='s1'>{description}</Text> */}
        </View>
    );
    const renderFooter = (): React.ReactElement => (
        <View style={styles.footerContainer}>
            <Button onPress={onSubmit} style={styles.footerControl}>{'CREATE'}</Button>
            <Button style={styles.footerControl} status='basic'>{'CANCEL'}</Button>
        </View>
    );


    const titleInput = useInputChanges();
    const descInput = useInputChanges();
    const [createCampaign, { data, loading, error }] = useMutation(M_CREATE_CAMPAIGN);

    const onSubmit = async () => {
        const user: any = getCurrentUser();
        console.log(titleInput, descInput, user);
        const response: any = await createCampaign({ variables: {
            title: titleInput.value,
            description: descInput.value
        }});
        console.log(response);
    }

    if (loading) {
        return (
            <PageLoadingIndicator />
        );
    }
    if (error) {
        console.log(`ERROR: const [createCampaign, { data, loading, error }] = useMutation(M_CREATE_CAMPAIGN);`, error)
        return (
            <>
                <Text>{'There was an error with the request'}</Text>
            </>
        );
    }

    return (
        <Layout level='3' style={{ flex: 1, padding: pageSpacerHorizontal }}>
            <Card header={renderHeader} footer={renderFooter} style={{ marginTop: HEADER_TOP_MARGIN}}>
                <Input
                    style={styles.input}
                    size='large'
                    placeholder='Camaign Title'
                    label='Camaign Title'
                    {...titleInput}
                />
                <Input
                    style={styles.input}
                    size='large'
                    placeholder='Camaign Description'
                    label='Camaign Description'
                    {...descInput}
                />
            </Card>
        </Layout>
    );

}


const styles = StyleSheet.create({
    input: {
        margin: 10,
    },
    footerContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        margin: 10,
        marginRight: 10,
    },
    footerControl: {
        // marginTop: 5,
        // marginBottom: 5,
        // paddingLeft: 10
    },
});